export enum PLAN_NAME {
  Free = '무료',
  Efficient = '실속형',
  Standard = '표준형',
  Special = '스페셜',
  SpecialPlus = '스페셜플러스',
  SpecialBaeminFesta = '스페셜_배민페스타',
  FreeTrial = '첫달무료',
  Franchise = '프랜차이즈',
  Partner = '파트너',
}

export const planToKor = {
  [PLAN_NAME.Free]: '무료',
  [PLAN_NAME.Efficient]: '실속형',
  [PLAN_NAME.Standard]: '표준형',
  [PLAN_NAME.Special]: '스페셜',
  [PLAN_NAME.FreeTrial]: '첫달 무료',
  [PLAN_NAME.Franchise]: '프랜차이즈',
  [PLAN_NAME.Partner]: '파트너',
  [PLAN_NAME.SpecialPlus]: '스페셜 플러스',
  [PLAN_NAME.SpecialBaeminFesta]: '스페셜 배민페스타',
} as Record<PLAN_NAME, string>;

export const planPrice = {
  [PLAN_NAME.Free]: 0,
  [PLAN_NAME.Efficient]: 6900,
  [PLAN_NAME.Standard]: 15900,
  [PLAN_NAME.Special]: 25000,
  [PLAN_NAME.SpecialPlus]: 40000,
};

export enum OfferingType {
  RETAIL = 'RETAIL',
  PARTNER = 'PARTNER',
  ENTERPRISE = 'ENTERPRISE',
  PROMOTIONAL = 'PROMOTIONAL',
}

export enum PLAN {
  STANDARD = 'standard',
  EFFICIENT = 'efficient',
  FREE = 'free',
  SPECIAL = 'special',
  SPECIAL_PLUS = 'special_plus',
}

export const originPlanToKor = {
  [PLAN.STANDARD]: '표준형',
  [PLAN.EFFICIENT]: '실속형',
  [PLAN.FREE]: '무료',
  [PLAN.SPECIAL]: '스페셜',
  [PLAN.SPECIAL_PLUS]: '스페셜 플러스',
} as Record<PLAN, string>;

export const originPlanToName = {
  [PLAN.STANDARD]: PLAN_NAME.Standard,
  [PLAN.EFFICIENT]: PLAN_NAME.Efficient,
  [PLAN.FREE]: PLAN_NAME.Free,
  [PLAN.SPECIAL]: PLAN_NAME.Special,
  [PLAN.SPECIAL_PLUS]: PLAN_NAME.SpecialPlus,
} as Record<PLAN, PLAN_NAME>;

export const specialPlans = [
  PLAN_NAME.Special,
  PLAN_NAME.SpecialPlus,
  PLAN_NAME.SpecialBaeminFesta,
] as PLAN_NAME[];
export const specialPlansOrigin = [PLAN.SPECIAL, PLAN.SPECIAL_PLUS];

// 일괄댓글(AI batch reply) 이용 가능 요금제 — 표준형 이상(표준형 + 스페셜 계열).
// PC/모바일 진입 게이트가 공유하는 단일 규칙(SSOT). 여기서만 정의하고 UI는 이 함수만 호출한다.
export const batchReplyAllowedPlans = [PLAN_NAME.Standard, ...specialPlans] as PLAN_NAME[];

export const canUseBatchReply = (plan?: PLAN_NAME) =>
  !!plan && batchReplyAllowedPlans.includes(plan);

export interface Plan {
  plan_id: number;
  name: string;
  price: number;
  created_at: Date | string;
  updated_at: Date | string;
  period: number;
  offering_type: OfferingType;
  origin_plan: PLAN;
  origin_plan_id?: number;
  discount_rate?: number;
  discount_amount?: number;
  display_message?: string;
  deleted_at?: Date | string | null;
  ref?: string;
}

/**
 * 연간 스페셜(1년 정기결제 스페셜) 판별 SSOT.
 * ⚠️ `period > 1`로 잡으면 안 됨 — RETAIL·special·period>1 에는 연간 외에도
 * `스페셜_배민페스타`(period 2, 단기 이벤트)가 존재. period>=12(진짜 연간)만 대상으로 한다.
 * 현재 해당: plan_id 29 스페셜(1년) / 36 스페셜(연간).
 */
export const isAnnualSpecialPlan = (
  plan?: Pick<Plan, 'offering_type' | 'origin_plan' | 'period'> | null,
): boolean =>
  plan?.offering_type === OfferingType.RETAIL &&
  plan?.origin_plan === PLAN.SPECIAL &&
  (plan?.period ?? 1) >= 12;

export const canSelfServeChangePlan = (offeringType?: OfferingType | null): boolean =>
  offeringType !== OfferingType.PARTNER;
